import React from 'react';

function useStickyTop(clientStickyTop = null) {
  const [stickyTop, setStickyTop] = React.useState(clientStickyTop);
  const sideElemRef = React.useRef(null);

  React.useLayoutEffect(() => {
    if (sideElemRef.current && clientStickyTop === null) {
      const {top} = sideElemRef.current.getBoundingClientRect();
      setStickyTop(top);
    }
  }, [clientStickyTop]);

  return {
    stickyTop,
    sideElemRef,
  };
}

export default useStickyTop;
